/* istanbul ignore file */
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-chat-hours-modal-window',
  templateUrl: './chat-hours-modal-window.component.html'
})
export class ChatHoursModalWindowComponent {

  constructor(
    public dialogRef: MatDialogRef<ChatHoursModalWindowComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) { }

  closeModal() {
    this.dialogRef.close();
  }
}
